import { render, staticRenderFns } from "./DataCards.vue?vue&type=template&id=c5acbc4a&"
import script from "./DataCards.vue?vue&type=script&lang=js&"
export * from "./DataCards.vue?vue&type=script&lang=js&"
import style0 from "./DataCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports